import { render, staticRenderFns } from "./BrainList.vue?vue&type=template&id=552eb0a7&scoped=true"
import script from "./BrainList.vue?vue&type=script&lang=js"
export * from "./BrainList.vue?vue&type=script&lang=js"
import style0 from "./BrainList.vue?vue&type=style&index=0&id=552eb0a7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552eb0a7",
  null
  
)

export default component.exports